export const NUMBER_REGEXP = /^[0-9\b]+$/;
export const PHONE_LENGTH = 10;
export const COMMENT_LENGTH = 1024;
/** Лимиты контактов гостя (payer-form, R-2): те же проверяет API, длиннее - 400 без платежа. */
export const PAYER_NAME_LENGTH = 100;
/** Предел адреса по RFC 5321. */
export const PAYER_EMAIL_LENGTH = 254;
export const DEFAULT_MESSAGE_DISPLAY_DURATION = 3000;
export const COMPLAIN_FORM_SUCCESS_MESSAGE_DURATION = 30000;
